export const toastSelector = state => state.toast;
